import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOMeta from '@/components/base/SEOMeta';
import HeroSection from './components/HeroSection';
import FeatureCards from './components/FeatureCards';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '永利皇宫·官方体验指南',
    url: 'https://embedded-expo.cn',
    description: '永利皇宫是澳门顶级综合度假胜地，汇聚五星级酒店、精致餐饮、高端娱乐与购物体验。',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '体育馆大马路',
      addressLocality: '路氹',
      addressRegion: '澳门',
      addressCountry: 'MO',
    },
    telephone: '+853-8889-8889',
  };

  return (
    <>
      <SEOMeta
        title="永利皇宫·官方体验指南"
        description="永利皇宫是澳门顶级综合度假胜地，汇聚五星级酒店、精致餐饮、高端娱乐与购物体验。本页为您全面呈现永利皇宫的预订攻略、设施亮点与尊享服务，助您规划完美澳门之旅。"
        keywords="永利皇宫,永利皇宫酒店预订,永利皇宫餐厅推荐,永利皇宫澳门攻略,永利皇宫套房体验,永利皇宫优惠"
        canonicalUrl="https://embedded-expo.cn/"
        schema={[
          orgSchema,
          {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '永利皇宫·官方体验指南',
            url: 'https://embedded-expo.cn',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '永利皇宫·官方体验指南 - 首页',
            description: '永利皇宫是澳门顶级综合度假胜地，汇聚五星级酒店、精致餐饮、高端娱乐与购物体验。',
          },
        ]}
      />

      <Navbar transparent />

      <main>
        <HeroSection />
        <FeatureCards />
        <CategoryNav />

        <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto text-center">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              为何选择永利
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-4">
              不止是度假，更是一种生活方式
            </h2>
            <p className="text-foreground-600 text-sm leading-relaxed max-w-2xl mx-auto mb-8">
              永利皇宫以「花」为设计灵感，将东方美学与西方奢华完美融合。
              从踏入大堂的那一刻起，您将被金色骏马雕像、旋转木马与花卉艺术装置所包围，
              每一处空间都诉说着永利对细节的极致追求。
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-10">
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-heading font-bold text-primary-600 mb-2">1,706</div>
                <div className="text-foreground-600 text-xs">间精致客房与套房</div>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-heading font-bold text-primary-600 mb-2">10+</div>
                <div className="text-foreground-600 text-xs">家米其林星级及推荐餐厅</div>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-heading font-bold text-primary-600 mb-2">50+</div>
                <div className="text-foreground-600 text-xs">个国际顶级奢侈品牌</div>
              </div>
            </div>
          </div>
        </section>

        <FeaturedArticles />

        <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-primary-500">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-background-50 mb-4">
              准备好开启您的永利皇宫之旅了吗？
            </h2>
            <p className="text-background-100/80 text-sm leading-relaxed mb-8">
              立即浏览我们的详细攻略，规划属于您的完美澳门假期
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/hotel"
                className="px-8 py-3 rounded-full bg-background-50 text-primary-700 font-medium text-sm whitespace-nowrap hover:bg-background-100 transition-all duration-300 cursor-pointer"
              >
                查看酒店房型
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 rounded-full bg-primary-400/30 border border-background-50/30 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-400/50 transition-all duration-300 cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        <FAQSection />
      </main>

      <Footer />
    </>
  );
}